import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createLeaveTypeMaster } from "../../redux/actions/leaveTypeActions";

const CreateLeaveMasterType = () => {
  const dispatch = useDispatch();
  const { creating, createError } = useSelector((state) => state.leaveType);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) return;

    dispatch(createLeaveTypeMaster(name, description));
    setName("");
    setDescription("");
  };

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-xl mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Master Leave Type</h1>

        {createError && (
          <div className="bg-red-100 text-red-700 border border-red-300 px-4 py-2 rounded mb-4">
            Error: {typeof createError === "string" ? createError : "Something went wrong"}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Name */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter leave type name"
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">Description</label>
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter description"
              className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-cyan-500 outline-none"
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={creating}
            className={`w-full px-4 py-2 text-white font-medium rounded-md transition ${
              creating ? "bg-gray-400 cursor-not-allowed" : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {creating ? "Creating..." : "Create Leave Type"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateLeaveMasterType;
